import { Modal, Box, Typography, TextField, Button } from "@mui/material";

const AddressModal = ({ modalShow, setModalShow }) => {
    return (
        <Modal
            open={modalShow.address}
            onClose={() => setModalShow({ ...modalShow, address: false })}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 4,
                    width: 400,
                }}
            >
                {/* Title */}
                <Typography variant="h6" component="h2" sx={{ mb: 2, textAlign: "center" }}>
                    Address Detail
                </Typography>

                <Typography variant="subtitle1" sx={{ mb: 1 }}> {modalShow?.data || "No address available"}</Typography>
                {/* Action Button */}
                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={() => setModalShow({ ...modalShow, address: false })}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddressModal;
